var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcContentInfo = function SvgIcContentInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "88px",
    viewBox: "0 0 88 88",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "CD661E6D-D952-432C-BD17-1C3A49D019B4")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.600000024
  }, /*#__PURE__*/React.createElement("g", {
    id: "brak-tre\\u015Bci",
    transform: "translate(-916.000000, -360.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M960,360 C984.300529,360 1004,379.699471 1004,404 C1004,428.300529 984.300529,448 960,448 C935.699471,448 916,428.300529 916,404 C916,379.699471 935.699471,360 960,360 Z M960,362.57 C937.118843,362.57 918.57,381.118843 918.57,404 C918.57,426.881157 937.118843,445.43 960,445.43 C982.881157,445.43 1001.43,426.881157 1001.43,404 C1001.43,381.118843 982.881157,362.57 960,362.57 Z M962.167969,394.640625 L962.167969,420 L957.832031,420 L957.832031,394.640625 L962.167969,394.640625 Z M960.035156,385.40625 C960.878906,385.40625 961.519531,385.648438 961.957031,386.132812 C962.394531,386.617188 962.613281,387.210938 962.613281,387.914062 C962.613281,388.617188 962.394531,389.203125 961.957031,389.671875 C961.519531,390.140625 960.878906,390.375 960.035156,390.375 C959.191406,390.375 958.554688,390.140625 958.125,389.671875 C957.695312,389.203125 957.480469,388.617188 957.480469,387.914062 C957.480469,387.210938 957.695312,386.617188 958.125,386.132812 C958.554688,385.648438 959.191406,385.40625 960.035156,385.40625 Z",
    id: "ic_info"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcContentInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_content_info.b65bdfb4.svg";
export { ForwardRef as ReactComponent };